// 搜索
const searchRouter = [{
  path: '/shopSearch',
  name: 'ShopSearch',
  component: () => import('@/views/searchResult/index')
}, {
  path: '/searchResult',
  name: 'SearchResult',
  component: () => import('@/views/searchResult/searchResult')
}]
export default searchRouter
